var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 170 170",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f7f7f7;}.cls-2{fill:none;stroke:#b53729;stroke-width:4px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85,
    cy: 85,
    r: 85
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.85,122.53a9.61,9.61,0,1,1-9.61-9.61A9.61,9.61,0,0,1,67.85,122.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.52,122.53a9.61,9.61,0,1,1-9.61-9.61A9.61,9.61,0,0,1,115.52,122.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.21,
    y1: 122.53,
    x2: 96.3,
    y2: 122.53
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "34.56 54.76 47.48 58.45 62.55 103.66 59.77 112.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.75,100.74a2.94,2.94,0,0,1-3.07,2.92H62.55L52.09,70.24h76.38Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 65.74,
    y1: 81.33,
    x2: 115.33,
    y2: 81.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 69.2,
    y1: 92.09,
    x2: 112.07,
    y2: 92.09
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.88fcdc2b809cd570ee7e4944cf975ee1.svg";
export { ForwardRef as ReactComponent };